import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UserAssignmentsComponent } from './user-assignments/user-assignments.component';
import { UserAssignmentsModalComponent } from './user-assignments-modal/user-assignments-modal.component';
import { MatCardModule } from '@angular/material/card';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDialogModule } from '@angular/material/dialog';
import { AssignmentsReportComponent } from './assignments-report/assignments-report.component';
import { AssignmentsFilterComponent } from './assignments-filter/assignments-filter.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { AssignmentSortPipe } from './assignments-sort/pipes/assignment-sort.pipe';
import { BillSortPipe } from './assignments-sort/pipes/bill-sort.pipe';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MaterialModule } from '../material/material.module';
import { RouterModule } from '@angular/router';

@NgModule({
    declarations: [
        UserAssignmentsComponent,
        UserAssignmentsModalComponent,
        AssignmentsReportComponent,
        AssignmentsFilterComponent,
        AssignmentSortPipe,
        BillSortPipe,
    ],
    imports: [
        CommonModule,
        RouterModule,
        MatCardModule,
        MatDialogModule,
        MatTabsModule,
        MatButtonModule,
        MatIconModule,
        FormsModule,
        MatSelectModule,
        MatTableModule,
        MatInputModule,
        MatDatepickerModule,
        ReactiveFormsModule,
        MatProgressSpinnerModule,
        MaterialModule,
    ],
    exports: [UserAssignmentsComponent, UserAssignmentsModalComponent],
})
export class AssignmentsModule {}
